import { EDUCATION  } from "actions/types";
import { baseStore } from "../common/baseStore"

export default baseStore(EDUCATION)
